import { Platforms } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

import { AI_MODELS_CONFIG } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/LLMConsts";
import type { IAiModelConfig } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";
import { LLModel } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";

const ALL_PLATFORMS_CONFIG: IAiModelConfig = {
    displayNameKey: "llm.model_selector.model.all",
    Icon: Platforms,
    iconName: "all-platforms",
    color: colorsPalettes.midnight[100],
};

export const DROPDOWN_MODELS: Record<LLModel, IAiModelConfig> = {
    [LLModel.All]: ALL_PLATFORMS_CONFIG,
    ...AI_MODELS_CONFIG,
};
